// extracted by mini-css-extract-plugin
export default {"root":"Form_root__OI+m+","itemCell":"Form_itemCell__YWzfF","item":"Form_item__Y9wje","contactButton":"Form_contactButton__8wKfE"};